import { render, staticRenderFns } from "./ArticleBodyV4.vue?vue&type=template&id=6e953b41&scoped=true&"
import script from "./ArticleBodyV4.vue?vue&type=script&lang=js&"
export * from "./ArticleBodyV4.vue?vue&type=script&lang=js&"
import style0 from "./ArticleBodyV4.vue?vue&type=style&index=0&id=6e953b41&scoped=true&lang=css&"
import style1 from "./ArticleBodyV4.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e953b41",
  null
  
)

export default component.exports